import { ItemProductType } from "@/types/enum/itemProductType";
import { ContentCategory } from "@/types/enum/contentCategory";
import { PageType } from "@/types/enum/pageType";
import { IStructuredDataInput, createStructuredDataContext } from "@/types/utils/seo/structuredData/types/context"
import { category, overviews, website, software, training, expert, service, content, type Builder } from "@/types/utils/seo/structuredData/types/templates"
import { Log } from "@/types/helpers/logHelper";

export function buildStructuredData({ vm, origin, currentPath, creator, currentCurrency }: IStructuredDataInput) {

    const pageType = vm?.seo?.pageType as PageType | undefined;
    const itemProductType = vm?.productType as ItemProductType | undefined;
    const MainLayoutitemProductType = vm?.mainLayout?.productType as ItemProductType | undefined;
    const contentCategories = vm?.filter?.contentCategories as ContentCategory | undefined;
    const contentCategory = vm?.contentCategory as ContentCategory | undefined;

    const context = createStructuredDataContext( vm, origin, currentPath, creator, currentCurrency );

    const pageTypeBuilders: Partial<Record<PageType, Builder>> = {
        [PageType.Content]: content,
        [PageType.ProductList]: overviews,
        [PageType.Overview]: overviews
    }

    const productTypeBuilders: Partial<Record<ItemProductType, Builder>> = {
        [ItemProductType.Software]: software,
        [ItemProductType.Training]: training,
        [ItemProductType.Expert]: expert,
        [ItemProductType.Service]: service
    }

    const categoryTypeBuilders: Partial<Record<ContentCategory, Builder>> = {}

    const categoriesTypeBuilders: Partial<Record<ContentCategory, Builder>> = {}

    const pageTypeBuilder = (pageType?: PageType) => ((pageType !== undefined ? pageTypeBuilders[pageType] : undefined) ?? website);

    const productTypeBuilder = (productType: ItemProductType, pageType?: PageType) => {
        if (productType === undefined) return website;
        if (productType === ItemProductType.Unknown) return pageTypeBuilder(pageType);
        return productTypeBuilders[productType] ?? website;
    };

    const categoryTypeBuilder = (Category: ContentCategory) => {
        if (Category === undefined) { return website; }
        return categoryTypeBuilders[Category] ?? category;
    }

    const categoriesTypeBuilder = (categories: ContentCategory) =>{
        if (categories === undefined) { return website; }
        return categoriesTypeBuilders[categories] ?? category;
    }

    const builder =
        (contentCategory && categoryTypeBuilder(contentCategory)) ||
        (contentCategories && categoriesTypeBuilder(contentCategories)) ||
        (itemProductType && productTypeBuilder(itemProductType, pageType)) ||
        (MainLayoutitemProductType && productTypeBuilder(MainLayoutitemProductType, pageType)) ||
        website;

    Log.log(builder);
    
    const structuredDataJson = JSON.stringify(builder(context));

    if (typeof document === "undefined") {
        Log.warn("buildStructuredData: document is undefined, skipping script injection.");
        return;
    }

    const id = "structured-data-json-ld";
    document.getElementById(id)?.remove();

    const script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.text = structuredDataJson;

    document.head.appendChild(script);
}